<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>钻头趟数管理</el-breadcrumb-item>
      <el-breadcrumb-item>钻头趟数列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="项目">
            <ProjectSelect v-model="filter.project_id"></ProjectSelect>
          </el-form-item>
          <el-form-item label="型号">
            <el-input
              size="small"
              v-model="filter.model_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="序列号">
            <el-input
              size="small"
              v-model="filter.serial_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <file-button
        v-code="23101"
        :filter="filter"
        :plain="false"
        obj="drill_trip"
        name="导入钻头趟数"
        @importCallback="getData(true)"
      ></file-button>

      <list-table :items="list"></list-table>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { drillTripList } from '@/service/getData'
import ProjectSelect from '../../../components/select/project_select.vue'
import listTable from './_table'

export default {
  components: {
    listTable,
    ProjectSelect,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        project_id: '',
        model_number: '',
        serial_number: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.project_id) {
      this.filter.project_id = parseInt(this.$route.query.project_id)
    }

    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.project_id = ''
        this.filter.model_number = ''
        this.filter.serial_number = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      let res = await drillTripList(params)
      this.total = res.data.count
      this.list = res.data.list
    },
  },
}
</script>